(() => {
  if (window.__MERAI_DRAWER_FIX__) return;
  window.__MERAI_DRAWER_FIX__ = true;

  const MATCHES = 63064826741107;
  const LIBRARY = 63064832704883;
  const GIFTS = new Set([MATCHES, LIBRARY]);
  const ELIGIBLE = new Set([
    15429273158003,
    15429273387379,
    15429273616755,
    15429273878899,
    15429274009971
  ]);

  const countCandles = (cart) => cart.items.reduce((sum, item) =>
    sum + (ELIGIBLE.has(Number(item.product_id)) ? Number(item.quantity || 0) : 0), 0);

  const compactGift = (variantId) => `
    <div class="merai-compact-gift">
      <div>
        <span class="merai-compact-gift__label ft2">COMPLIMENTARY GIFT</span>
        <p class="merai-compact-gift__title">${Number(variantId) === MATCHES ? 'Signature Matches' : 'The Scent Library'}</p>
      </div>
      <span class="merai-compact-gift__included ft2">INCLUDED</span>
    </div>`;

  function ladderMarkup(count) {
    const capped = Math.min(count, 3);
    const progress = count === 2 ? 50 : count >= 3 ? 100 : 0;
    const message = count === 0
      ? 'Add two candles to unlock Signature Matches.'
      : count === 1
        ? 'Add one more candle to unlock Signature Matches.'
        : count === 2
          ? 'Signature Matches unlocked. Add one more candle for the Scent Library.'
          : 'Scent Library unlocked — included with your order.';

    const one = count === 1 ? ' is-current' : count >= 2 ? ' is-passed' : '';
    const two = count === 2 ? ' is-current' : count >= 3 ? ' is-passed' : '';
    const three = count >= 3 ? ' is-current' : '';

    return `
      <div class="merai-gift-ladder__top">
        <p class="merai-gift-ladder__eyebrow ft2">YOUR COMPLIMENTARY GIFT</p>
        <span class="merai-gift-ladder__count ft2">${capped}/3</span>
      </div>
      <p class="merai-gift-ladder__message" aria-live="polite">${message}</p>
      <div class="merai-gift-ladder__track" role="progressbar" aria-valuemin="0" aria-valuemax="3" aria-valuenow="${capped}" aria-label="Complimentary gift progress">
        <span class="merai-gift-ladder__line"></span>
        <span class="merai-gift-ladder__fill" style="width:${progress}%"></span>
        <div class="merai-gift-step${one}"><i></i><span class="ft2">1 CANDLE</span><strong>First room</strong></div>
        <div class="merai-gift-step${two}"><i></i><span class="ft2">2 CANDLES</span><strong>Matches</strong></div>
        <div class="merai-gift-step${three}"><i></i><span class="ft2">3 CANDLES</span><strong>Scent Library</strong></div>
      </div>`;
  }

  function renderLiveDrawer(runtime, cart) {
    const drawer = document.querySelector('cart-drawer');
    const header = drawer?.querySelector('#CartDrawer .drawer__inner > .h4');
    if (!drawer || !header) return;

    drawer.querySelector('[data-merai-gift-progress="drawer"]')?.remove();

    const count = countCandles(cart);
    let ladder = drawer.querySelector('[data-merai-gift-ladder]');
    if (!ladder) {
      ladder = document.createElement('div');
      ladder.dataset.meraiGiftLadder = '';
      header.insertAdjacentElement('afterend', ladder);
    }
    ladder.className = 'merai-gift-ladder';
    ladder.hidden = cart.items.length === 0;
    if (ladder.dataset.state !== String(count)) {
      ladder.innerHTML = ladderMarkup(count);
      ladder.dataset.state = String(count);
    }

    const giftRows = [];
    cart.items.forEach((item, index) => {
      const variantId = Number(item.variant_id);
      if (!GIFTS.has(variantId)) return;
      const row = drawer.querySelector(`#CartDrawer-Item-${index + 1}`);
      if (!row) return;
      row.classList.add('merai-gift-line');
      row.dataset.meraiGiftVariant = String(variantId);
      if (!row.querySelector('.merai-compact-gift')) row.innerHTML = compactGift(variantId);
      row.hidden = false;
      giftRows.push(row);
    });
    giftRows.forEach((row) => {
      if (row.parentElement?.lastElementChild !== row) row.parentElement?.appendChild(row);
    });

    const paidCount = cart.items.reduce((sum, item) =>
      sum + (GIFTS.has(Number(item.variant_id)) ? 0 : Number(item.quantity || 0)), 0);
    drawer.querySelectorAll('[data-cart-render="item_count"]').forEach((node) => {
      if (node.textContent !== String(paidCount)) node.textContent = String(paidCount);
    });
  }

  function suppressRedundantMeraiPublish() {
    if (window.__MERAI_GIFT_PUBLISH_PATCHED__ || typeof window.publish !== 'function') return;

    const originalPublish = window.publish;
    window.publish = function patchedPublish(eventName, payload) {
      const isMeraiGiftRefresh =
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        eventName === PUB_SUB_EVENTS.cartUpdate &&
        payload?.source === 'merai-gifts';

      if (isMeraiGiftRefresh) return Promise.resolve([]);
      return originalPublish.apply(this, arguments);
    };

    window.__MERAI_GIFT_PUBLISH_PATCHED__ = true;
  }

  function patch(runtime) {
    if (runtime.__liveDrawerPatched) return;
    runtime.__liveDrawerPatched = true;

    suppressRedundantMeraiPublish();

    const originalProgress = runtime.renderProgress.bind(runtime);
    runtime.renderProgress = (cart) => {
      originalProgress(cart);
      renderLiveDrawer(runtime, cart);
    };

    runtime.enhanceGiftLines = () => {
      if (runtime.lastCart) renderLiveDrawer(runtime, runtime.lastCart);
    };

    customElements.whenDefined('cart-drawer').then(() => {
      const prototype = customElements.get('cart-drawer')?.prototype;
      if (!prototype || prototype.__meraiDrawerRenderPatched) return;
      const original = prototype.renderContents;
      if (typeof original !== 'function') return;
      prototype.renderContents = function(state) {
        const result = original.call(this, state);
        requestAnimationFrame(() => runtime.schedule(0));
        return result;
      };
      prototype.__meraiDrawerRenderPatched = true;
    });

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const observer = new MutationObserver((mutations) => {
        if (runtime.isApplyingSections || document.body.classList.contains('merai-cart-syncing')) return;
        const nativeCartChange = mutations.some((mutation) =>
          [...mutation.addedNodes, ...mutation.removedNodes].some((node) =>
            node.nodeType === 1 &&
            (node.matches?.('.cart-item, cart-drawer-items, .drawer__inner') ||
             node.querySelector?.('.cart-item, cart-drawer-items, .drawer__inner'))
          )
        );
        if (nativeCartChange) runtime.schedule(0);
      });
      observer.observe(drawer, { childList: true, subtree: true });
    }

    document.addEventListener('click', (event) => {
      if (event.target.closest('cart-drawer .qty-btn, cart-drawer cart-remove-button')) {
        setTimeout(() => runtime.schedule(0), 380);
      }
    }, true);

    document.addEventListener('change', (event) => {
      if (event.target.closest('cart-drawer .quantity__input')) {
        setTimeout(() => runtime.schedule(0), 380);
      }
    }, true);

    runtime.schedule(0);
  }

  function waitForRuntime(attempt = 0) {
    if (window.MeraiCartRuntime) {
      patch(window.MeraiCartRuntime);
      return;
    }
    if (attempt < 80) setTimeout(() => waitForRuntime(attempt + 1), 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForRuntime(), { once: true });
  } else {
    waitForRuntime();
  }
})();
